// extracted by mini-css-extract-plugin
export default {"header":"Header_header__J0gWb","content":"Header_content__ca-Fz","headerImg":"Header_headerImg__VY-E2"};